(() => {
  if (customElements.get('cc-hero-montage')) return;
  class HeroMontage extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.video = this.querySelector('video');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.video.muted = true;
      this.video.loop = true;
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .1;
        this.sync();
      }, { threshold: [0, .1] });
      this.observer.observe(this.video);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => this.sync(), options);
    }
    shouldPlay() {
      return this.isConnected && this.visible && !document.hidden && !this.motion.matches;
    }
    sync() {
      if (!this.shouldPlay()) {
        this.video.pause();
        return;
      }
      this.video.play().then(() => {
        if (!this.shouldPlay()) this.video.pause();
      }).catch(() => {});
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.video?.pause();
      this.abort = null;
    }
  }
  customElements.define('cc-hero-montage', HeroMontage);
})();
